import config from '../config/config'

const state = {
    SESSION_CLEAR_TIME_MINUTES: 1440,
    isAddBoard: false,
    boards: [],
    board: {},
    card: {},
    bodyColor: '#ffffff',
    navbarColor: '#026aa7',
    isShowBoardSettings: false,
    //user
    session_id: null,
    user_id: null,
    user_level: null,
    session_time: null,
    //
    CDN_URL: config.getCndUrl,
    
    post_template_info: [],
    gms_server_type: null,
    gms_server_name: null,

    // get_option_gms
    item_info: [],
    const: [],
    category_list: [],
    title_list: [],
    const_refresh_flag: true,

    // same_recommend defalut localization
    
    selected_game_package:'',
    selected_game_server:'1',
    selected_ad_os:'Android',
    selected_ad_language:'KO',


    recent_img_quiz_log_data: [], //가장최근에 불러온 퀴즈데이터 
    recent_img_quiz_log_data_info:'',


    
    //채굴기 캐싱
    cpu_dash_borad_info: {},
    user_list_cpu_sort_recent:[],   //최신순
    user_list_cpu_sort_referee:[],  //추천인순 
    user_list_cpu_sort_cur_bp:[],         //
    user_list_cpu_sort_daily_bp:[],
    user_list_cpu_sort_point:[],
    user_list_cpu_sort_point_total:[],


    //퀴즈앤캐시 캐싱
    quizcash_dash_borad_info: {},
    user_list_quizcash_sort_recent:[],   //최신순
    user_list_quizcash_sort_referee:[],  //추천인순 
    user_list_quizcash_sort_cur_bp:[],         //
    user_list_quizcash_sort_daily_bp:[],
    user_list_quizcash_sort_point:[],
    user_list_quizcash_sort_point_total:[],


    //금나르기 캐싱
    carrygold_dash_borad_info: {},
    user_list_carrygold_sort_recent:[],   //최신순
    user_list_carrygold_sort_gem:[],      //현재 보유보석
    user_list_carrygold_sort_gem_total:[],
    user_list_carrygold_sort_point:[],    //현재보유골드
    user_list_carrygold_sort_point_total:[],
    user_list_carrygold_sort_bp:[],          //현재 채굴량
    user_list_carrygold_sort_referee:[],      //추천인수

    // 하우스 애드
    housead_app_list: [],
    housead_reward_types: [],
    housead_app_reward_settings: [],  // [{ appId, rewardTypeId }]
    housead_ad_configs: [],           // [{ appId, adType, excludedAppIds, rewardTypeId, active: 'Y'|'N' }]
    housead_ad_config_order: [],  // [appId, ...] 표시 순서 (기본: 동일앱 제외 PID DESC)

};

export default state;